(function () {
const afterElementMotion = (element, callback) => {
  const finish = () => callback?.();
  requestAnimationFrame(() => {
    const animations = element?.getAnimations?.().filter(animation => animation.playState !== 'finished');
    if (!animations?.length) {
      finish();
      return;
    }
    Promise.allSettled(animations.map(animation => animation.finished)).then(finish);
  });
};

const normalizeReturnOrderForSubject = (value) =>
  String(value || "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "-")
    .replace(/[^A-Z0-9#-]/g, "")
    .replace(/-+/g, "-")
    .slice(0, 40);

const initReturnSubject = () => {
  const form = document.getElementById('return-cancellation-form');
  const orderInput = form?.querySelector('#order-id');
  const subjectField = form?.querySelector('#form-subject');
  if (!orderInput || !subjectField) return;

  const updateSubject = () => {
    const orderNumber = normalizeReturnOrderForSubject(orderInput.value);
    subjectField.value = orderNumber ? `RETOURVERZOEK-${orderNumber}` : 'RETOURVERZOEK';
  };

  updateSubject();
  orderInput.addEventListener('input', updateSubject);
};

const initMerchantContentLinks = () => {
  const safeProtocols = new Set(['http:', 'https:', 'mailto:', 'tel:']);
  document
    .querySelectorAll('.page-layout__content a[href], .page a[href], .faq__answer a[href]')
    .forEach((link) => {
      const rawHref = link.getAttribute('href') || '';
      const isSingleSlashPath = rawHref.startsWith('/') && !rawHref.startsWith('//');
      if (isSingleSlashPath || rawHref.startsWith('#')) return;

      let url;
      try {
        url = new URL(rawHref, window.location.href);
      } catch {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        return;
      }

      if (!safeProtocols.has(url.protocol)) {
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        return;
      }

      if (link.target === '_blank') {
        const relValues = new Set((link.rel || '').split(/\s+/).filter(Boolean));
        relValues.add('noopener');
        relValues.add('noreferrer');
        link.rel = Array.from(relValues).join(' ');
      }
    });
};

const initPageEnhancements = () => {
  initReturnSubject();
  initMerchantContentLinks();
};

document.addEventListener('click', e => {
  const target = e.target.closest('.page-layout__toggle');
  if (target) {
    target.setAttribute('aria-expanded', target.getAttribute('aria-expanded') !== 'true');
    target.nextElementSibling?.classList.toggle('page-layout__nav--open');
    return;
  }

  const summary = e.target.closest('.page-layout__faq-summary');
  const details = summary?.closest('.page-layout__faq-details');
  if (summary && details) {
    e.preventDefault();
    const classList = details.classList;
    if (details.open) {
      classList.add('closing');
      afterElementMotion(details.querySelector('.page-layout__faq-answer-wrapper'), () => {
        details.open = false;
        classList.remove('closing');
      });
    } else {
      classList.add('opening');
      details.open = true;
      details.offsetHeight;
      classList.remove('opening');
    }
  }
});

document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initPageEnhancements) : initPageEnhancements();
})();
